import { IToolkitMenuModel } from '@/components/buttons/IToolkitMenuModel';
import ResourcePlanning from '../ResourcePlanningModel';

export default class ProjectMenu {
  public readonly resourcePlanning: ResourcePlanning;

  public model: IToolkitMenuModel = {
    command: {
      id: 'Project',
      name: 'Project',
      icon: 'fas fa-project-diagram',
      execute: () => undefined
    },
    getEntries: () =>
      Promise.resolve([
        {
          id: 'NewProject',
          name: 'Projekt hinzufügen',
          icon: 'fas fa-file-medical',
          group: 'root',
          execute: () => {
            this.resourcePlanning.wizardNewProject.show();
          }
        },
        {
          id: 'DeleteProject',
          name: 'Projekt löschen',
          icon: 'fas fa-trash-alt',
          group: 'root',
          disabled: () =>
            this.resourcePlanning.ganttModel.selectedGanttTask == undefined ||
            this.resourcePlanning.ganttModel.selectedGanttTask.id == undefined,
          execute: () => {
            if (
              this.resourcePlanning.ganttModel.selectedGanttTask == undefined ||
              this.resourcePlanning.ganttModel.selectedGanttTask.id == undefined
            ) {
              return;
            }
            this.resourcePlanning.dialogDeleteProject.show();
          }
        }
      ])
  };

  constructor(resourcePlanning: ResourcePlanning) {
    this.resourcePlanning = resourcePlanning;
  }
}
